export default __webpack_public_path__ + "static/media/edit-gold.ead5a5a9.svg";